import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';

// Components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import LoadingSpinner from '../../elements/LoadingSpinner.js';
import { Input } from '../../elements/Input.js';
import Button from '../../components/CustomButton/CustomButton.jsx';
import Select from '../../elements/Select';
import { getTwoFactorReasonOptions } from '~/utils/constants';
import newlogo from '../../assets/img/new-logo.png';

class Recover2FAPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            redirectToLogin: false,
            comment: '',
            reason: null,
            otp: '',
            otpSent: false,
            receivedTimer: 0,
            timeRemaining: 0,
            isResendEnabled: false,
        };
        this.interval = null;
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);
        const urlToken = params.get('token');

        if (urlToken) {
            window.sessionStorage.setItem('x-1fa-token', urlToken);
            window.history.replaceState(null, '', window.location.pathname);
            this.setState({ loading: false });
        } else if (!window.sessionStorage.getItem('x-1fa-token')) {
            this.setState({ redirectToLogin: true, loading: false });
        } else {
            this.setState({ loading: false });
        }
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);
    }

    startTimer = (resendWait) => {
        if (this.interval) clearInterval(this.interval);
        this.interval = setInterval(() => {
            const timeLeft = resendWait - Date.now();
            if (timeLeft <= 0) {
                clearInterval(this.interval);
                this.setState({ timeRemaining: 0, isResendEnabled: true });
            } else {
                this.setState({ timeRemaining: Math.ceil(timeLeft / 1000) });
            }
        }, 1000);
    };

    handleGetOtp = (e) => {
        e.preventDefault();
        const { reason, comment } = this.state;
        const { authStore, t } = this.props;
        if (!reason || (reason.value === t('Other') && !comment.trim())) return;
        authStore
            .getRecover2FA()
            .then((res) => {
                this.setState(
                    { otpSent: true, receivedTimer: res.resendWait, isResendEnabled: false, timeRemaining: 0 },
                    () => { if (res.resendWait) this.startTimer(res.resendWait); }
                );
            })
            .catch((e) => {
                console.error(e);
            });
    };

    handleResend = () => {
        this.setState({ isResendEnabled: false }, () => {
            const { authStore } = this.props;
            authStore
                .getRecover2FA()
                .then((res) => {
                    this.setState(
                        { isResendEnabled: false, timeRemaining: 0 },
                        () => { if (res.resendWait) this.startTimer(res.resendWait); }
                    );
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        const { authStore, commonStore, t } = this.props;
        const { otp, comment, reason } = this.state;
        const resolvedComment = reason && reason.value !== t('Other') ? reason.value : comment;
        try {
            const response = await authStore.recover2FA(otp, resolvedComment);
            commonStore.addNotification(t(response.message), null, 'success');
            this.props.router.navigate('/login');
        } catch (error) {
            console.error('2FA recovery failed:', error);
        }
    };

    render() {
        const { t } = this.props;
        const { loading, redirectToLogin, comment, reason, otp, otpSent, timeRemaining, isResendEnabled } = this.state;

        if (loading) return <LoadingSpinner />;
        if (redirectToLogin) return <Navigate to="/login" replace />;

        const reasonOptions = getTwoFactorReasonOptions(t);

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Recover').toUpperCase()} {t('2FA')}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        {!otpSent ? (
                            <>
                                <form className="login-container" onSubmit={this.handleGetOtp}>
                                    <div className="row mt-12">
                                        <div className="col-md-12 col-lg-12 col-sm-12">
                                            <div className="form-group">
                                                <label className="fw-bold">
                                                    {t('Reason')}
                                                </label>
                                                <label className="red-star">*</label>
                                                <div className='mt-1'>
                                                    <Select
                                                        options={reasonOptions}
                                                        value={reason}
                                                        onChange={(selected) => this.setState({ reason: selected, comment: '' })}
                                                        placeholder={t('Select a reason')}
                                                        required
                                                    />
                                                </div>
                                                {reason && reason.value === t('Other') && (
                                                    <Input
                                                        className="mt-2"
                                                        placeholder={t('Enter a reason')}
                                                        value={comment}
                                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                                        maxLength={255}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn btn-block fwBold fs18 loginbutton" type="submit" onSubmit={this.handleGetOtp}>
                                        {t('Get recovery code')}
                                    </button>
                                </form>
                            </>
                        ) : (
                            <>
                                <p className="forogottext mb-3">
                                    {t('We have sent a recovery code to your email. Please check your email and enter the code below.')}
                                </p>
                                <form className="login-container" onSubmit={this.handleSubmit}>
                                    <div className="row mt-12">
                                        <div className="col-md-12 col-lg-12 col-sm-12">
                                            <div className="form-group business-name">
                                                <label htmlFor="reason" className="fw-bold">
                                                    {t('Recovery Code')}
                                                </label>
                                                <label className="red-star">*</label>
                                                <input
                                                    id="otp"
                                                    type="number"
                                                    value={otp}
                                                    className="form-control login-input mb_25 mt-12"
                                                    placeholder={t('Enter recovery code')}
                                                    required
                                                    onChange={(e) => this.setState({ otp: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <button className="btn btn-block fwBold fs18 loginbutton" type="submit">
                                        {t('Recover')}
                                    </button>
                                </form>
                            </>
                        )}
                        <div className="d-flex w-100 justify-content-between align-items-center mt-3 mb-3">
                            <button
                                className="fs18 loginFooter border-none"
                                onClick={() => this.props.router.navigate('/login')}
                            >
                                {t('Back to login')}
                            </button>
                            <span>
                                {isResendEnabled ? (
                                    <button
                                        type="button"
                                        className="fs16 loginFooter border-none"
                                        onClick={this.handleResend}
                                    >
                                        {t('Resend code')}
                                    </button>
                                ) : (
                                    timeRemaining > 0 && (
                                        <span className="fs12">
                                            {t('Expires in')} {timeRemaining} {t('seconds')}
                                        </span>
                                    )
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore', 'commonStore', 'userStore')(applicationRouter(withLocalization(observer(Recover2FAPage))));
